module.exports = __webpack_public_path__ + "static/media/activity-user.2bbc6ba3.svg";